import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { ErrorHandlerService, IError } from './error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorResolver implements Resolve<IError> {

  constructor(private errorHandler: ErrorHandlerService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IError> | IError {
    return this.errorHandler.getError();
  }
}
